import axios from "axios";
import SubjectBranch from "./SubjectBranch";

export default class Branches {
  public m_subjectsBranches: SubjectBranch[] = [];

  constructor(subjectsBranches: SubjectBranch[]) {
    this.m_subjectsBranches = subjectsBranches;
  }

  static async build() {
    
    // TODO UNCOMMENT THIS WHEN WE HAVE THE NEW SUBJECTS -> CACHE FOR THE NEW SUBJECTS
    // const data2 = await Branches.fetchSubjectsBranches();
    // console.log(data2)



    const data = [
        {
            "branch_name": "Comunes",
            "subjects": [
                {
                    "subject_id": "1",
                    "subject_name": "Anglès",
                    "subject_icon": "mdi-chess-queen",
                    "subject_path": "angles",
                    "subject_hide": "0"
                },
                {
                    "subject_id": "2",
                    "subject_name": "Història",
                    "new_subject_name": null,
                    "subject_icon": "mdi-chess-rook",
                    "subject_path": "historia",
                    "subject_hide": "0"
                },
                {
                    "subject_id": "21",
                    "subject_name": "Història de la filosofia",
                    "subject_icon": "mdi-lightbulb-on-outline",
                    "subject_path": "historia-de-la-filosofia",
                    "subject_hide": "0"
                },
                {
                    "subject_id": "3",
                    "subject_name": "Llengua castellana",
                    "subject_icon": "mdi-fountain-pen-tip",
                    "subject_path": "llengua-castellana",
                    "subject_hide": "0"
                },
                {
                    "subject_id": "4",
                    "subject_name": "Llengua catalana",
                    "subject_icon": "mdi-book-open-variant",
                    "subject_path": "llengua-catalana",
                    "subject_hide": "0"
                }
            ]
        },
        {
            "branch_name": "Ciència i Tecnologia",
            "subjects": [
                {
                    "subject_id": "5",
                    "subject_name": "Biologia",
                    "subject_icon": "mdi-bacteria",
                    "subject_path": "biologia",
                    "subject_hide": "0"
                },
                {
                    "subject_id": "32",
                    "subject_name": "Ciències Generals",
                    "new_subject_name": null,
                    "subject_icon": "mdi-web",
                    "subject_path": "ciencies-generals",
                    "subject_hide": "0"
                },
                {
                    "subject_id": "6",
                    "subject_name": "Ciències de la terra",
                    "subject_icon": "mdi-image-filter-vintage",
                    "subject_path": "ciencies-de-la-terra",
                    "subject_hide": "0"
                },
                {
                    "subject_id": "7",
                    "subject_name": "Dibuix tècnic",
                    "subject_icon": "mdi-android-studio",
                    "subject_path": "dibuix-tecnic",
                    "subject_hide": "0"
                },
                {
                    "subject_id": "9",
                    "subject_name": "Física",
                    "subject_icon": "mdi-rocket",
                    "subject_path": "fisica",
                    "subject_hide": "0"
                },
                {
                    "subject_id": "11",
                    "subject_name": "Matemàtiques",
                    "subject_icon": "mdi-pi-box",
                    "subject_path": "matematiques",
                    "subject_hide": "0"
                },
                {
                    "subject_id": "10",
                    "subject_name": "Química",
                    "subject_icon": "mdi-flask-empty",
                    "subject_path": "quimica",
                    "subject_hide": "0"
                },
                {
                    "subject_id": "12",
                    "subject_name": "Tecnologia industrial",
                    "new_subject_name": null,
                    "subject_icon": "mdi-boom-gate-up",
                    "subject_path": "tecnologia-industrial",
                    "subject_hide": "0"
                }
            ]
        },
        {
            "branch_name": "Humanitats i Socials\t",
            "subjects": [
                {
                    "subject_id": "18",
                    "subject_name": "Economia de l'empresa",
                    "subject_icon": "mdi-currency-usd",
                    "subject_path": "economia-de-l-empresa",
                    "subject_hide": "0"
                },
                {
                    "subject_id": "19",
                    "subject_name": "Geografia",
                    "subject_icon": "mdi-earth",
                    "subject_path": "geografia",
                    "subject_hide": "0"
                },
                {
                    "subject_id": "26",
                    "subject_name": "Història de l'art",
                    "new_subject_name": null,
                    "subject_icon": "mdi-brush",
                    "subject_path": "historia-de-l-art",
                    "subject_hide": "0"
                },
                {
                    "subject_id": "22",
                    "subject_name": "Literatura castellana",
                    "subject_icon": "mdi-wind-turbine",
                    "subject_path": "literatura-castellana",
                    "subject_hide": "0"
                },
                {
                    "subject_id": "23",
                    "subject_name": "Literatura catalana",
                    "new_subject_name": null,
                    "subject_icon": "mdi-lighthouse",
                    "subject_path": "literatura-catalana",
                    "subject_hide": "0"
                },
                {
                    "subject_id": "25",
                    "subject_name": "Matemàtiques CC.SS.",
                    "new_subject_name": null,
                    "subject_icon": "mdi-equalizer",
                    "subject_path": "matematiques-cs",
                    "subject_hide": "0"
                }
            ]
        },
        {
            "branch_name": "Arts",
            "subjects": [
                {
                    "subject_id": "13",
                    "subject_name": "Anàlisi musical",
                    "subject_icon": "mdi-music",
                    "subject_path": "analisi-musical",
                    "subject_hide": "0"
                },
                {
                    "subject_id": "30",
                    "subject_name": "Arts Escèniques",
                    "subject_icon": "mdi-drama-masks",
                    "subject_path": "arts-esceniques",
                    "subject_hide": "0"
                },
                {
                    "subject_id": "40",
                    "subject_name": "Cor i Tècnica Vocal",
                    "new_subject_name": null,
                    "subject_icon": "mdi-account-voice",
                    "subject_path": "cor-tecnica-vocal",
                    "subject_hide": "0"
                },
                {
                    "subject_id": "38",
                    "subject_name": "Dibuix Tècnic Aplicat a les Arts Plàstiques i el Disseny",
                    "subject_icon": "mdi-pencil-ruler",
                    "subject_path": "dibuix-tecnic-aplicat-arts-disseny",
                    "subject_hide": "0"
                },
                {
                    "subject_id": "14",
                    "subject_name": "Dibuix artístic",
                    "subject_icon": "mdi-camera-image",
                    "subject_path": "dibuix-artistic",
                    "subject_hide": "0"
                },
                {
                    "subject_id": "15",
                    "subject_name": "Disseny",
                    "subject_icon": "mdi-auto-fix",
                    "subject_path": "disseny",
                    "subject_hide": "0"
                },
                {
                    "subject_id": "16",
                    "subject_name": "Fonaments de les arts",
                    "subject_icon": "mdi-palette",
                    "subject_path": "fonaments-de-les-arts",
                    "subject_hide": "0"
                },
                {
                    "subject_id": "35",
                    "subject_name": "Història de la Música i de la Dansa",
                    "subject_icon": "mdi-dance-ballroom",
                    "subject_path": "historia-de-la-musica-i-de-la-dansa",
                    "subject_hide": "0"
                },
                {
                    "subject_id": "37",
                    "subject_name": "Literatura dramàtica",
                    "subject_icon": "mdi-drama-masks",
                    "subject_path": "literatura-dramatica",
                    "subject_hide": "0"
                },
                {
                    "subject_id": "36",
                    "subject_name": "Moviments culturals i artístics",
                    "new_subject_name": null,
                    "subject_icon": "mdi-image-frame",
                    "subject_path": "moviments-culturals-i-artistics",
                    "subject_hide": "0"
                },
                {
                    "subject_id": "39",
                    "subject_name": "Tècniques d'Expressió Graficoplàstiques",
                    "subject_icon": "mdi-brush-variant",
                    "subject_path": "teniques-d-expressio-graficoplastiques",
                    "subject_hide": "0"
                }
            ]
        },
        {
            "branch_name": "Clàssiques i estrangeres",
            "subjects": [
                {
                    "subject_id": "29",
                    "subject_name": "Alemany",
                    "subject_icon": "mdi-glass-mug-variant",
                    "subject_path": "alemany",
                    "subject_hide": "0"
                },
                {
                    "subject_id": "28",
                    "subject_name": "Francès",
                    "subject_icon": "mdi-food-croissant",
                    "subject_path": "frances",
                    "subject_hide": "0"
                },
                {
                    "subject_id": "20",
                    "subject_name": "Grec",
                    "new_subject_name": null,
                    "subject_icon": "mdi-alpha",
                    "subject_path": "grec",
                    "subject_hide": "0"
                },
                {
                    "subject_id": "27",
                    "subject_name": "Italià",
                    "new_subject_name": null,
                    "subject_icon": "mdi-pizza",
                    "subject_path": "italia",
                    "subject_hide": "0"
                },
                {
                    "subject_id": "24",
                    "subject_name": "Llatí",
                    "new_subject_name": null,
                    "subject_icon": "mdi-pillar",
                    "subject_path": "llati",
                    "subject_hide": "0"
                }
            ]
        }
    ]
  
    const branches = data.map((obj) => new SubjectBranch(obj));
    return new Branches(branches);
  }

  private static async fetchSubjectsBranches(): Promise<SubjectBranch[]> {
    try {
      const {data} = await axios.get('/subjects-branches');
      return data
    } catch (e) {
      console.error(e);
    }
  }


  public getSubjectsBranches(): SubjectBranch[] {
    return this.m_subjectsBranches;
  }


}
